import { render } from "./ChallengeView.vue?vue&type=template&id=27655b15"
import script from "./ChallengeView.vue?vue&type=script&lang=js"
export * from "./ChallengeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__